import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {FormCardComponent} from "./card/form-card.component";
import {SaraInputA2Component} from "./sara-input/sara-input-a2.component";
import {SaraRadioComponent} from "./sara-radio/sara-radio.component";
import {SaraSelectComponent} from "./sara-select/sara-select.component";
import {SaraSelectorComponent} from "./sara-selector/sara-selector.component";
import {EvaButtonComponent} from "./eva-button/eva-button.component";
import {ListCardComponent} from "./list-card/list-card.component";
import {EvaPagerComponent} from "./pager/eva-pager.component";
import {FeedbackComponent} from "./feedback/feedback.component";
import {EvaButtonGhostComponent} from "./eva-button-ghost/eva-button-ghost.component";
import {EvaMessageComponent} from "./eva-message/eva-message.component";
import {NgModelWc} from "../core/ngmodel-for-wc";
import {RadioContainerComponent} from "./radio-container/radio-container.component";
import {InputContainerComponent} from "./input-container/input-container.component";
import {CheckboxContainerComponent} from "./checkbox-container/checkbox-container.component";
import {SelectContainerComponent} from "./select-container/select-container.component";

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateModule],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [FormCardComponent, SaraInputA2Component, SaraRadioComponent, SaraSelectComponent, SaraSelectorComponent,
        EvaButtonComponent, ListCardComponent, EvaPagerComponent, FeedbackComponent, EvaButtonGhostComponent, EvaMessageComponent,
        NgModelWc,RadioContainerComponent,InputContainerComponent,CheckboxContainerComponent, SelectContainerComponent],
    exports: [FormCardComponent, SaraInputA2Component, SaraRadioComponent, SaraSelectComponent, SaraSelectorComponent,
        EvaButtonComponent, ListCardComponent, EvaPagerComponent, FeedbackComponent, EvaButtonGhostComponent, EvaMessageComponent,
        NgModelWc,RadioContainerComponent,InputContainerComponent,CheckboxContainerComponent, SelectContainerComponent]
})
export class SharedModule {}


// WEBPACK FOOTER //
// ./public/upgrade/shared/shared.module.ts